const SvgUkrytaOscieznica60 = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 60 60">
    <path fill="#373737" d="M26 2H15v56h30v-9h-2v7H17V4h9z" />
    <path fill="#373737" d="M20.5 28a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" />
  </svg>;
export default SvgUkrytaOscieznica60;